import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import PackagesTable from "../components/Packages/PackagesTable";

const Packages = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div>
      <Box sx={{ px: 4, pt: 8, pb: 4 }}>
        <Typography variant="h3" className="sectionTitle">
          Packages
        </Typography>
        <Typography sx={{ mt: 4, textAlign: isMobile ? "left" : "justify" }} variant="body1">
          SivooTV+ brings U.S. residents a traditional television viewing
          experience wherever connected to the internet, four (4) different
          packages are offered with each their own array of programming, there
          is something to satisfy everyone on every budget. A bonus feature is
          that five (5) simultaneous sessions are allowed per active
          subscription—so feel free to share your account with friends and
          family.
        </Typography>
      </Box>
      <PackagesTable />
    </div>
  );
};

export default Packages;
